import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Sale } from '../sale';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../accounting/branch';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdSearchBoxComponent } from '@covalent/core';
import { SalesService } from '../sales.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { ReportService } from '../../../shared/services/report.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { DateRangeDialogComponent } from '../../../shared/dialogs/date-range-dialog/date-range-dialog.component';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-refund-list',
  templateUrl: './refund-list.component.html',
  styleUrls: ['./refund-list.component.scss'],
  providers: [ReportService]
})
export class RefundListComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Sale[];
  subscription: Subscription = new Subscription();
  totalMetersValue: number = 0;

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'order_number', label: 'Order #', tooltip: 'some tooltip example' },
    { name: 'invoice_number', label: 'Invoice #' },
    { name: 'customer_name', label: 'Client' },
    { name: 'salesman', label: 'Salesman' },
    { name: 'order_date', label: 'Date' },
    { name: 'pieces', label: 'Pieces' },
    { name: 'quantity', label: 'QTY (M)' },
    { name: 'branch', label: 'Branch' },
    { name: 'status', label: 'Status' }
  ];

  filteredData: any[] = [];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _salesService: SalesService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _reportService: ReportService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._salesService
      .getRefunds()
      .subscribe((sales: Sale[]) => {
        this.data = sales.filter((sale: Sale) => { return this._authService.getUserBranches().some((b: Branch) => { return b.code == sale['branch_code'] }) });;;
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        //this.selectedRows = this.filteredData;
        this.filter();
        this.totalMetersValue = this.data.reduce((acc, el) => acc + +el.qty, 0);

        this._loadingService.resolve('loading');

      });

    //Use user's branches instead
    //this.allBranches$ = this._salesService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('return')) {
      this._searchBox.value = this._settingsService.getSearchTerm('return');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('return', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('return'), true, excludedColumns);
    this.filteredTotal = newData.length;

    // Sort by date works differently
    if (this.sortBy == 'order_date') {
      newData = newData.sort(
        (d1, d2) => {
          return (new Date(d2[this.sortBy]).getTime() - new Date(d1[this.sortBy]).getTime()) * (this.sortOrder == TdDataTableSortingOrder.Ascending ? 1 : -1)
        }
      );
    } else {
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  total(data: any[], field: string) {
    if (!data) return;

    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) || '0' }, 0);
  }

  /*salesReport() {
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getSalesReportData(result.from, result.to).subscribe(
            reportData => {
              this._reportService.salesReport(reportData, result.from, result.to);
            }
          );
        }
      }
    );
  }

  branchTransferReport() {
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getTransferReportData(result.from, result.to).subscribe(
            reportData => {
              this._reportService.branchTransferReport(reportData, result.from, result.to);
            }
          );
        }
      }
    );
  }*/

  openConfirm(): void {
    this._dialogService.openConfirm({
      message: 'Are you sure that you want to delete this item?',
      disableClose: false,
      title: 'Confirm',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.selectedRows.forEach(
          r => {
            this._salesService.deleteOneRefund(r.id).subscribe(
              response => {
                if (response['status'] == 'SUCCESS') {
                  // Remove this one
                  this._dialogService.openAlert(
                    {
                      title: 'SUCCESS',
                      message: 'Order Deleted ' + r.order_number
                    }
                  );
                  this.data = this.data.filter(d => { return d.id != r.id });
                  this.filter();
                } else {
                  this._dialogService.openAlert(
                    {
                      title: 'WARNING',
                      message: 'Could not delete order ' + r.order_number
                    }
                  );
                }
              }
            );
          }
        );
      } else {
        // TODO DO SOMETHING ELSE
      }
    });
  }

  selectAll() {
    let selected = !this.allSelected();

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } else {
      this.selectedRows = [];
    }

  }

  select(selected: boolean, row) {
    console.log(selected);

    if (selected) {
      if (!this.selectedRows.some(item => { return item.id == row.id })) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id })
    }
  }

  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }

  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected.id == row.id });
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/refund-list/refund-list.component.ts